'use strict';
import {keyBy, find, reject, map} from 'lodash'
import {STATES} from '../../../../common/data/uiData'
import {REVIEWBUILDER_CONTENT_PROVIDERS} from "../../ReviewsTabData";
import FeaturesStore from '../../../../modules/app/FeaturesStore'

angular.module('clientDashboardApp').directive('reviewRow', function () {

  return {
    restrict: 'A',
    replace: true,
    transclude: true,
    template: require('./reviewRow.html'),
    controller: ($scope, reviewService, locationService, $window, userService) => {
      const states = STATES;

      const review = $scope.review;

      $scope.hideMarkNotMine = angular.isDefined($scope.hideMarkNotMine) ? $scope.hideMarkNotMine : (REVIEWBUILDER_CONTENT_PROVIDERS.indexOf(review.contentProvider) === -1 && !$scope.customProviders[review.contentProvider])

      $scope.userReadOnly = !!$scope.user && _.contains($scope.user.permissions,'ReadOnly');

      $scope.getTasks = function() {
        return $scope.review.tasks || []
      }

      function setReviewBuilderReviewUrl() {
        if ($scope.brandConfig && review.contentProvider === $scope.brandConfig.reviewBuilderProviderName) {
          review.reviewURL = $window.location.protocol + "//" + ($scope.brandConfig.hostname  || window.location.host) + review.reviewURL
        }
      }

      $scope.$watch('brandConfig',(newVal,oldVal) => {
        if(oldVal !== newVal){
          setReviewBuilderReviewUrl()
        }
      },1)

      setReviewBuilderReviewUrl();

      $scope.hideRow = typeof $scope.hide === "undefined" ? false : $scope.hide
      $scope.hideToolbar = typeof $scope.hideToolbar === "undefined" ? false : $scope.hideToolbar

      $scope.embeddedReviewDetails = (() => {
        if (review.syndicatedReviews && review.syndicatedReviews.length) {
          let providers = _.uniq(_.map(review.syndicatedReviews, (item) => (item.contentProvider)));
          return {
            providers,
            multipleProviders: providers.length > 1,
            hasEmbeddedReviewDetails: true,
            tooltip: `You can only respond to these shared reviews on ${review.contentProvider.toLowerCase()}`,
            label: "Also On:"
          }
        } else if (review.originalContentProvider && review.originalContentProvider !== review.contentProvider) {
          return {
            providers: [review.originalContentProvider],
            multipleProviders: false,
            hasEmbeddedReviewDetails: !!review.originalReview,
            tooltip: review.originReview ?
              `This review is originally from ${review.originalContentProvider.toLowerCase()}` :
              `This review is originally from ${review.originalContentProvider.toLowerCase()}, but has not yet been linked by our system`,
            label: "From:"
          }
        } else {
          return null;
        }
      })();

      $scope.nps = null;


      let user = userService.getCurrentUser()
      $scope.pulseDisabled = !FeaturesStore.pulseEnabled
      $scope.workflow2Disabled = !FeaturesStore.workflow2Enabled

      $scope.showResponderLink = () => {
        return $scope.review.responseUrl && $scope.brandConfig && !$scope.brandConfig.restrictions.hideExternalResponseLink
      }

      $scope.setNps = () => {
        if($scope.review && $scope.review.reviewData){
          $scope.nps = find($scope.review.reviewData,{name:'nps'})
        }
      }

      $scope.setNps();

      if($scope.review.reviewData){
        $scope.review.reviewData = $scope.review.reviewData.filter(item => item.name !== "nps")
      }

      $scope.hasTrackedTopics = (review) => {
        return review.sentimentResult ? review.sentimentResult.topics.length > 0 : false;
      }

      $scope.camelToTitleCase = text => {
        return text.replace(/([a-z])((?=[A-Z]))/,'$1,$2').split(',').map(word => (word.charAt(0).toUpperCase() + word.substring(1,word.length))).join(' ')
      }

      $scope.formatTopic = function (topicClassification) {
        return topicClassification.topic
      }

      $scope.markNotMine = (reviewId) => {
        $scope.ignoreReviewPopup.apply(this, [reviewId])
      }

      $scope.reviewHasTag = (review, tag) => {
        return !!find(review.reviewTags, (item) => {
          return tag ? item._id.$oid === tag.id : item._id.$oid === $scope.tagSettings.selectedTag.id
        });
      }


      $scope.hasSelectableTags = (review) => {
        var tagFound = find($scope.tagsForAccount, (item) => (!$scope.reviewHasTag(review, item)))
        return tagFound
      }


      $scope.addReviewTag = (review, tag) => {
        $scope.tagSettings.state = states.updating
        const tagWithOID = {...tag, ["_id"]: {"$oid": tag.id}}
        reviewService.addReviewTag(review.reviewId, tagWithOID).then((resp) => {
          var newTag = resp.data;
          review.reviewTags ? review.reviewTags.push(newTag) : review.reviewTags = [newTag]
          $scope.tagSettings.state = states.success
        }, (error) => {
          $scope.tagSettings.state = states.error
        })
        $scope.tagSettings.selectedTag = ""
      }

      $scope.selectTagFilter = (review) => ((item) => (!$scope.reviewHasTag(review, item)))

      $scope.isAccountTag = (tag) => {
        return find($scope.tagsForAccount, (item) => (item.id == tag._id.$oid))
      }

      $scope.removeReviewTag = (review, tag) => {
        $scope.tagSettings.state = states.updating;
        reviewService.removeReviewTag(review.reviewId, tag._id.$oid).then((resp) => {
          var tagId = resp.data;
          // This was clearing the selected filter
          // if($scope.searchConfig){
          //   $scope.searchConfig.tags = reject($scope.searchConfig.tags, (item) => (item == tagId))
          // }
          review.reviewTags = reject(review.reviewTags, (item) => (item._id.$oid == tagId));
          $scope.tagSettings.state = states.success;

          $scope.$emit('reviewTagReview', $scope.review)

          // should view update to
        }, (error) => {
          $scope.tagSettings.state = states.error
        })
      }

      $scope.findTrackedTopic = (topic) => {
        return $scope.topicEditor.keyedTrackedTopics[topic.topic] ? $scope.topicEditor.keyedTrackedTopics[topic.topic] : false
      }

      $scope.activeSetChanged = (activeSet) => {
        $scope.topicEditor.setId = activeSet['_id']['$oid'];
        $scope.topicEditor.activeSet = activeSet;
        $scope.topicEditor.defaultTopicSetName = activeSet['name'];
        $scope.topicEditor.trackedTopics = activeSet.trackedTopics;
        $scope.topicEditor.keyedTrackedTopics = keyBy(activeSet.trackedTopics, 'topic')
      }

      $scope.closeTopicEditor = () => {
        $scope.topicEditor.isOpen[$scope.topicEditor.selectedReviewId + $scope.topicEditor.selectedTopic.topic.topic] = false
      }

      $scope.resetTopicEditor = () => {
        $scope.topicEditor.selectedTopic = false
        $scope.topicEditor.state = states.init
      }

      $scope.setSelectedTopic = (reviewId, topic) => {
        $scope.topicEditor.selectedReviewId = reviewId
        $scope.topicEditor.selectedPrimaryTopic = {}
        $scope.topicEditor.selectedTopic = topic;
        $scope.topicEditor.isOpen[reviewId + topic.topic] = true;
        const maybeTrackedTopic = $scope.findTrackedTopic(topic)
        $scope.topicEditor.selectedTopic.subTopics = maybeTrackedTopic ? maybeTrackedTopic.subTopics : []
      }

      $scope.initiateReviewResponse = () => {
        if($scope.review.responseUrl && !$scope.brandConfig.restrictions.hideExternalResponseLink){
          $window.open($scope.review.responseUrl,'_blank')
        }
        else if (angular.isDefined($scope.onShowResponseForm)) {
          $scope.onShowResponseForm({ reviewId: $scope.review.reviewId})
        }
      }

      $scope.selectLocation = (groupId) => {
        locationService.setSelectedGroupId(groupId)
      }

    }

  };
});
